<table>
  <small>
    <tr>
      <td>
        <lh-time-picker [(ngModel)]="from" (change)="updateTimeInterval()" [disabled]="isOpenAllDay"></lh-time-picker>
      </td>
      <td>
        <span class="time-period-separator">—</span>
      </td>
      <td>
        <lh-time-picker [(ngModel)]="to" (change)="updateTimeInterval()" [disabled]="isOpenAllDay"></lh-time-picker>
      </td>
    </tr>
  </small>
</table>
